import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';

/** Desktop floating action button (FAB) wheel menu taps. */
export const trackFabMenuClick = (
  action: string,
  page_path?: string,
  label: string | null = null
): void => {
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.FAB_MENU,
    action,
    label,
    view_id: PULSE_CLICK_CATEGORY.FAB_MENU,
    page_id: PULSE_CLICK_CATEGORY.FAB_MENU,
    page_path: path,
  });
};

export const trackFabStoreLocatorClick = (page_path?: string): void =>
  trackFabMenuClick(PULSE_CLICK_ACTION.TAP_STORE_LOCATOR, page_path);

export const trackFabRecentOrderClick = (page_path?: string): void =>
  trackFabMenuClick(PULSE_CLICK_ACTION.TAP_RECENT_ORDER, page_path, null);

export const trackFabRewardsLinkClick = (page_path?: string): void =>
  trackFabMenuClick(PULSE_CLICK_ACTION.TAP_REWARDS_LINK, page_path, null);
